import {Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {TopBarComponent} from "../component/top-bar/top-bar.component";
import {MenuBarComponent} from "../component/menu-bar/menu-bar.component";
import {HomeSliderComponent} from "../component/home-slider/home-slider.component";
import {FooterComponent} from "../component/footer/footer.component";
import {AbstractComponent} from "../component/abstract/abstract.component";
import {SuccessStoryComponent} from "../component/success-story/success-story.component";
import {BrandLogosComponent} from "../component/brand-logos/brand-logos.component";
import {FeatureSectionComponent} from "../component/feature-section/feature-section.component";
import {DevelopersHelpComponent} from "../component/developers-help/developers-help.component";
import {PerformanceSectionComponent} from "../component/performance-section/performance-section.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-home',
  standalone: true,
    imports: [
        TopBarComponent,
        MenuBarComponent,
        HomeSliderComponent,
        FooterComponent,
        AbstractComponent,
        SuccessStoryComponent,
        BrandLogosComponent,
        FeatureSectionComponent,
        DevelopersHelpComponent,
        PerformanceSectionComponent,
        NgIf
    ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent extends TemplateComponent implements OnInit{
    activeItem:any={};
    success_stories:any={};
    service_features:any={};

  ngOnInit() {
      this.titleService.setTitle("Search as a Service")
      this.meta.addTag({name:'keywords',content:"search,saas,marketing,search engin"},true);
      this.meta.addTag({name:'description',content:"Search as a service"},true);
      this.success_stories = JSON.parse(this.global.getMainData()['main-page']['data'])['success_stories'];
      this.service_features = JSON.parse(this.global.getMainData()['main-page']['data'])['service_features'];
      this.activeItem = this.global.getMainData()['main-page'] != null ? JSON.parse(this.global.getMainData()['main-page']['data'])['active-items']:'';
      setTimeout(()=>{
          this.activeItem = this.global.getMainData()['main-page'] != null ?JSON.parse(this.global.getMainData()['main-page']['data'])['active-items']:'';
          this.success_stories = JSON.parse(this.global.getMainData()['main-page']['data'])['success_stories'];
          this.service_features = JSON.parse(this.global.getMainData()['main-page']['data'])['service_features'];
      },1000)
    // super.ngOnInit();
  }

}
